
import { PackageCardProps } from './package-card.component';

const usePackageCard = (props: PackageCardProps) => {
    return {};
};

export default usePackageCard;
